import { inject, type InjectionKey } from 'vue';
import type { TableColumnStaticProps } from '@/types/tableTypes';
import type { InspectorFieldGroup } from '@/composables/searchInspectorFieldGroups';

/**
 * What a record body tells the inspector it hosts. RecordBody provides it on
 * the record page, in the side peek and in the list's pane.
 * An inspector shown without a record body gets nothing, and keeps its own
 * pull-down and built-in grouping. With it:
 *
 * - their section switcher draws as real tabs instead of a pull-down, and each
 *   change is reported so the page can keep it in the address (`?tab=`);
 * - their Details fields come from the person's chosen layout instead of the
 *   built-in grouping.
 */
export interface RecordPageContext {
    onSectionChange: (section: string) => void;
    /** The Details groups for these columns, or null to keep the built-in grouping. */
    groupsFor: (columns: TableColumnStaticProps[], excludeFields: string[]) => InspectorFieldGroup[] | null;
}

export const RECORD_PAGE_CONTEXT: InjectionKey<RecordPageContext> = Symbol('recordPageContext');

/** Null outside a record body. */
export function useRecordPageContext(): RecordPageContext | null {
    return inject(RECORD_PAGE_CONTEXT, null);
}
